var FormElement = /** @class */ (function () {
    function FormElement(config) {
        // production js loses the class name, so have to keep it as prop
        this.componentName = '';
        this.config = config;
        this.name = config.name;
        this.label = config.label;
        this.conditionalRender = config.conditionalRender;
        this.value = undefined === config.value ? this.getDefaultValue() : config.value;
        this.required = undefined === config.required ? false : config.required;
    }
    FormElement.prototype.shouldRenderLabel = function () {
        return !!this.label;
    };
    FormElement.prototype.shouldRender = function (values) {
        if (!this.conditionalRender) {
            return true;
        }
        return this.conditionalRender(values);
    };
    FormElement.prototype.getValue = function () {
        return this.value;
    };
    FormElement.prototype.getDefaultValue = function () {
        return '';
    };
    FormElement.prototype.isRequired = function () {
        return this.required;
    };
    FormElement.prototype.setValue = function (value) {
        this.value = value;
    };
    FormElement.prototype.getComponentName = function () {
        return this.componentName;
    };
    return FormElement;
}());
export default FormElement;
